import {NgxDcNavbarLinkInfo} from "@devcrate/ngx-dc-navbar";

export const COMPONENTS_LINKS = <NgxDcNavbarLinkInfo[]>[
  {
    type: 'link',
    path: "/training/",
    title: "Training",
    icon: "first_page",
  },
  {
    type: 'link',
    path: "/packages/",
    title: "Node Libraries",
    icon: "first_page",
  },
  {
    type: 'heading',
    title: 'Components',
  },
  {
    type: 'link',
    path: "/components/navbar",
    title: "Navbar",
    icon: "side_navigation",
  },
  {
    type: 'link',
    path: "/components/side-pane-list",
    title: "Side Pane List",
    icon: "table_rows",
  },
  {
    type: 'link',
    path: "/components/dropdown",
    title: "Dropdown",
    icon: "dropdown",
  },
  {
    type: 'link',
    path: "/components/mat-select-data-source",
    title: "Mat Select Data Source",
    icon: "dropdown",
  },
  {
    type: 'link',
    path: "/components/file-viewer",
    title: "File Viewer",
    icon: "picture_as_pdf",
  },
  {
    type: 'link',
    path: "/components/upload-file-button",
    title: "Upload File Button",
    icon: "upload_file",
  },
  {
    type: 'link',
    path: "/components/demo-card",
    title: "Demo Card",
    icon: "integration_instructions",
  },
  {
    type: 'heading',
    title: 'Utils',
  },
  {
    type: 'link',
    path: "/components/data-sources",
    title: "Data Sources",
    icon: "storage",
  },
  {
    type: 'link',
    path: "/components/role-authorized",
    title: "Role Authorized",
    icon: "engineering",
  },
  {
    type: 'link',
    path: "/components/modal-service",
    title: "Modal Service",
    icon: "launch",
  },
  {
    type: 'link',
    path: "/components/file-service",
    title: "File Service",
    icon: "article",
  },
  {
    type: 'link',
    path: "/components/destroy-observable",
    title: "Destroy Observable",
    icon: "auto_delete",
  },
  {
    type: 'heading',
    title: 'Styles',
  },
  {
    type: 'link',
    path: "/components/material-styling",
    title: "Material Styling",
    icon: "format_color_fill",
  },
]

export const PACKAGE_LINKS: NgxDcNavbarLinkInfo[] = [
  {
    type: 'link',
    path: "/components",
    title: "Components",
    icon: "first_page",
  },
  {
    type: 'link',
    path: "/training/",
    title: "Training",
    icon: "first_page",
  },
  {
    type: 'heading',
    title: 'Node Packages',
  },
  {
    type: 'link',
    path: "/packages/eslint-config",
    title: "ESLint Config",
    icon: "storage",
  },
  {
    type: 'link',
    path: "/packages/playwright",
    title: "Playwright Utils",
    icon: "storage",
  },
  {
    type: 'link',
    path: "/packages/node-utils",
    title: "Node Utilities",
    icon: "storage",
  },
]

export const TRAINING_LINKS: NgxDcNavbarLinkInfo[] = [
  {
    type: 'link',
    path: "/components/",
    title: "Components",
    icon: "first_page",
  },
  {
    type: 'link',
    path: "/packages/",
    title: "Node Libraries",
    icon: "first_page",
  },
  {
    type: 'heading',
    title: 'Angular Training',
  },
  {
    type: 'link',
    path: "/training/basics",
    title: "Angular Basics",
    icon: "school",
  },
  {
    type: 'link',
    path: "/training/advanced",
    title: "Advanced Angular",
    icon: "school",
  },
  {
    type: 'link',
    path: "/training/structural-directives",
    title: "Structural Directives",
    icon: "school",
  },
]

